import { GET } from './index'

// Mirror of api/subjects.js — same function names. The Odin endpoint returns
// each subject with both `name` and `title` so the legacy frontend works
// unchanged.
//
// `getSubjectById` has no direct Odin equivalent yet (subjects are exposed as
// a list per authenticated teacher via TeacherCapability). Until an endpoint
// is added we resolve it client-side from the same list. If the list grows
// large or the caller needs richer data, build a proper endpoint in
// classfy-api and replace this implementation.

export const findSubjects = () => GET({ url: '/api/instructor/subjects' })

export const getSubjectById = async id => {
  const list = await findSubjects()
  const match = Array.isArray(list) ? list.find(s => s.id === id) : null
  if (!match) {
    const error = new Error('Subject not found')
    error.statusCode = 404
    throw error
  }
  return match
}
